import React from 'react'

import Panel from '../../Classroom/components/Main/Panel'
import { useSketchpadState } from '../hooks'

const Main = () => {
  const sketchpad = useSketchpadState()

  const panels = sketchpad.panels.filter((t) => t === 'sketch')

  return (
    <div className={`classroom-components`}>
      {panels.length ? (
        panels.map((v) => <Panel type={v} key={v} />)
      ) : (
        <div className='gp-Sketchpad-fallback'>
          Open Sketch on the main device to start
        </div>
      )}
    </div>
  )
}

export default Main
